import { Select } from 'antd';
import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { remote_getAllProvinces } from '../../../typescript/apis/AdministrativeAPIs';
import { Province_Base } from '../../../typescript/models/Administrative';

export interface ProvinceSelectorProps {
  defaultValue: string; //gid_1
  onChange: Function;
}

interface OptionType {
  label: string; // category.name
  value: string; // category.id.toString()
}

const ProvinceSelector = (props: ProvinceSelectorProps) => {
  const { t } = useTranslation();

  // display value
  const [options, setOptions] = useState<OptionType[]>();

  useEffect(() => {
    remote_getAllProvinces().then((data: Province_Base[]) => {
      const provinces = data;
      const options: OptionType[] = [
        ...provinces.map((item: Province_Base) => {
          let resultItem: OptionType = {
            label: `${item.type_1} ${item.name_1}`,
            value: item.gid_1,
          };
          return resultItem;
        }),
      ];
      setOptions(options);
    });
  }, []);

  const onChange = (value: string) => {
    if (props.onChange) {
      if (value) {
        props.onChange(value);
      } else {
        props.onChange('');
      }
    }
  };

  const onSearch = (value: string) => {
    // console.log('search:', value);
  };

  // Filter `option.label` match the user type `input`
  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  // offline filter
  return (
    <Select
      showSearch
      placeholder={t('province')}
      optionFilterProp="children"
      onChange={onChange}
      onSearch={onSearch}
      filterOption={filterOption}
      options={options}
      value={props.defaultValue?.toString()}
      style={{ width: '100%' }}
    />
  );
};

export default memo(ProvinceSelector);
